import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function FullscreenHeatmap({
  open,
  dismiss,
  base64,
  alt,
}: {
  open: boolean;
  dismiss: () => void;
  base64: string;
  alt: string;
}) {
  if (!open) return null;

  return (
    <div className="tf-pnt-mobile-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="tf-pnt-mobile-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="tf-pnt-mobile-fullscreen-rotate">
        <img
          className="tf-pnt-mobile-fullscreen-image"
          src={`data:image/png;base64,${base64}`}
          alt={alt}
        />
      </div>
      <span className="tf-pnt-mobile-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
